export default __webpack_public_path__ + "static/media/poxa-lulu-avatar.d5fbae96.png";